import { Select, type SelectProps } from 'antd';

export interface AppSelectProps<
  ValueType = unknown,
> extends SelectProps<ValueType> {}

export const AppSelect = <ValueType,>({
  options,
  showSearch = true,
  optionFilterProp = 'label',
  style,
  className,
  ...props
}: AppSelectProps<ValueType>) => {
  return (
    <Select<ValueType>
      className={className}
      options={options}
      showSearch={showSearch}
      optionFilterProp={optionFilterProp}
      style={{ width: '100%', ...style }}
      {...props}
    />
  );
};